<template>
    <div>
        <div class="flex filter_table">
            <div class="flex flex_column w_100">
                <CustomRatingTable :filters="filters"></CustomRatingTable>
            </div>
            <CustomRatingFilter @apply-filter="applyFilter"/>
        </div>
    </div>
</template>

<script>
import CustomRatingTable from "@/components/templates/investor/customRating/CustomRatingTable";
import CustomRatingFilter from "@/components/templates/investor/customRating/CustomRatingFilter";

export default {
		components: {
			CustomRatingFilter,
			CustomRatingTable
        },
		data() {
			return {
				filters: [],
			};
		},
		methods: {
			applyFilter(filters) {
				this.filters = filters;
			},
		}
	}
</script>